<template>
    <span @click="toggleShowMode" class="pointer">
        {{ formattedDate }}
    </span>
</template>

<script>
const moment = require('moment');

export default {
    name: 'DateFromNow',
    props: {
        iniDate: {
            type: [String, Number],
        },
        showNormal: {
            type: Boolean,
        },
        iniDateFormat: {
            type: String,
        },
    },
    data() {
        return {
            showMode: 'FROMNOW',
            dateFormat: 'Do MMMM YYYY, HH:mm',
        };
    },
    computed: {
        formattedDate() {
            if (this.showMode == 'FROMNOW') {
                let locale = this.$i18n.locale;
                return moment(this.iniDate).locale(locale).fromNow(); //format("DD-MM-YYYY HH:mm");
            }
            return moment(this.iniDate).format(this.dateFormat);
        },
    },
    watch: {
        showNormal() {
            this.handleProps();
        },
    },
    created() {
        this.handleProps();
    },
    methods: {
        handleProps() {
            if (this.showNormal) {
                this.showMode = 'NORMAL';
            }
            if (this.iniDateFormat) {
                this.dateFormat = this.iniDateFormat;
            }
        },
        toggleShowMode() {
            if (this.showMode == 'NORMAL') {
                this.showMode = 'FROMNOW';
            } else {
                this.showMode = 'NORMAL';
            }
        },
    },
};
</script>
